var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import payform from './violation-purchase-payform.vue';
import qrcodeResult from './violation-purchase-qrcode-result.vue';
import qrcodeCreated from './violation-purchase-qrcode-created.vue';
import cookie from '../../cookie/cookie';
export default Vue.extend({
    name: 'qrCode',
    components: {
        'el-payform': payform,
        'el-qrcode-created': qrcodeCreated,
        'el-qrcode-result': qrcodeResult,
    },
    computed: __assign({ amount: function () {
            return this.purchaseParams.amount;
        } }, mapState('violationManage', {
        qrStatus: 'qrStatus',
    })),
    data: function () {
        return {
            usernameZh: '',
            active: 'payform',
            times: '',
            purchaseParams: null,
            url: '',
            purchaseCode: '',
        };
    },
    created: function () {
        this.getUserName();
    },
    methods: {
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        formDataCallback: function (params) {
            this.toSweep(params);
        },
        toSweep: function (_a) {
            var data = _a.data, ref = _a.ref, form = _a.form;
            var amount = data.amount, times = data.times;
            this.purchaseParams = Object.assign({}, data);
            this.$store.dispatch('violationManage/PURCHASE_TIME', {
                data: {
                    amount: amount,
                    times: times,
                    type: 'SCAN_CODE_PAY',
                    operator: this.usernameZh,
                },
                callback: this.getOrderId,
            });
        },
        getOrderId: function (res) {
            var _this = this;
            if (!res.data)
                return this.$message.error('预下单失败，请重试！');
            var _a = res.data, purchaseCode = _a.purchaseCode, tenantCode = _a.tenantCode;
            this.purchaseCode = purchaseCode;
            this.$request({
                url: '/proxy/qrcode',
                method: 'post',
            }).then(function (res) {
                if (!res)
                    return;
                if (res.errorCode === 0) {
                    var url = res.data.url;
                    _this.url = url + "?purchasecode=" + purchaseCode + "&tenantcode=" + tenantCode;
                    _this.active = 'created';
                    return;
                }
                _this.$message.error('获取二维码失败！请重试');
            });
        },
        toPayForm: function (_a) {
            var times = _a.times, active = _a.active;
            this.active = 'payform';
            this.times = times;
        },
    },
    watch: {
        qrStatus: function (StatusMsg) {
            if (!StatusMsg)
                return;
            this.active = 'result';
        },
    },
});
